// extracted by mini-css-extract-plugin
export default {"text32":"Text_Regular_32_text32__X7FYp"};